import Vue from 'vue'
import 'virtual:svg-icons-register'
import SvgIcon from '@/components/svgIcon/SvgIcon.vue'

Vue.component('svg-icon', SvgIcon)
